import {
  FiPackage,
  FiClipboard,
  FiFileText,
  FiShoppingCart,
  FiLayout,
  FiXCircle,
  FiSettings,
  FiGrid,
  FiHome,
  FiTruck,
  FiTarget
} from 'react-icons/fi';
import React from 'react';
import { SALES_URL } from '../env';

// Define the types for the menu items and sub-menu items
export interface SubMenuItem {
  label: string;
  path: string;
  subMenu?: SubMenuItem[];
  permission?: string;
}

export interface MenuItem {
  label: string;
  icon: any; // Using any type to avoid TypeScript errors
  path?: string;
  subMenu?: SubMenuItem[];
  permission?: string;
}

const menuItems: MenuItem[] = [
  {
    label: 'Dashboard',
    icon: FiHome,
    path: '/',
    permission: 'sales_dashboard'
  },
  {
    label: 'Sales Items',
    icon: FiPackage,
    path: SALES_URL + '/sales-item/listing',
    permission: 'sales_item_menu'
  },
  {
    label: 'Sales Pipeline',
    icon: FiTarget,
    path: SALES_URL + '/sales-pipeline',
    permission: 'sales_pipline_menu'
  },
  {
    label: 'Enquiries',
    icon: FiClipboard,
    path: SALES_URL + '/enquiry/enquiry-listing',
    permission: 'enquiry_menu'
  },
  {
    label: 'Quotations',
    icon: FiFileText,
    permission: 'quotation_menu',
    subMenu: [
      {
        label: 'Quotations',
        path: SALES_URL + '/quotation/quotation-listing',
        permission: 'quotation_submenu'
      },
      {
        label: 'Quotations Approval',
        path: SALES_URL + '/quotation/quotation-approval-list/requests',
        permission: 'quotation_approval_submenu'
      },

      { 
        label: 'Quotations VMI Approval', 
        path: SALES_URL + '/vmi-quotation/quotation-approval-list/internal-pending', 
        permission: 'quotation_vmi_approval_submenu' 
      },

    ],
  },
  {
    label: 'Sales Order',
    icon: FiShoppingCart,
    permission: 'saleorder_menu',
    subMenu: [
      {
        label: 'SO Awaiting Confirmation',
        path:  SALES_URL + '/salesorder/unconfirmed-salesorder',
        permission: 'so_awaiting_confirmation_menu'
      },
      {
        label: 'Confirmed Sales Orders',
        path:  SALES_URL + '/salesorder/salesorder-listing',
        permission: 'saleorder_menu'
      }
    ],
  },
  {
    label: 'Back Order',
    icon: FiTruck,
    path: SALES_URL + '/backorder/backorder-listing',
    permission: 'backorder_menu',
  },
  {
    label: 'Invoice',
    icon: FiLayout,
    permission: 'invoice_menu',
    subMenu: [
      {
        label: 'Account Receivable',
        path: SALES_URL + '/invoice/invoice-listing',
        permission: 'account_recivable_menu'
      },
      {
        label: 'Paid Invoices',
        path: SALES_URL + '/invoice/paid-invoice-listing',
        permission: 'paid_invoice_listing_menu'
      },
      {
        label: 'RMA',
        path: SALES_URL + '/rma/rma-listing',
        permission: 'rma_menu'
      },
    ],
  },
  {
    label: 'Cancelled SO',
    icon: FiXCircle,
    path: SALES_URL + '/salesorder/cancel-so-listing',
    permission: 'cancel_so_menu',
  },
  {
  label: 'VMI',
  icon: FiGrid,
  permission: 'vmi_menu',
  subMenu: [
    {
      label: 'VMI Open Salesorder',
      path: SALES_URL + '/vmi/vmi-salesorder-listing?type=vmi-salesorder&mode=open',
      permission: 'saleorder_menu'
    },
    {
      label: 'VMI Closed Salesorder',
      path: SALES_URL + '/vmi/vmi-closed-salesorder-listing?type=vmi-salesorder&mode=closed',
      permission: 'saleorder_menu'
    },
    {
      label: 'VMI Cancel Salesorder',
      path: SALES_URL + '/vmi/vmi-cancel-salesorder-listing?type=vmi-salesorder',
      permission: 'cancel_so_menu'
    },
    {
      label: 'VMI Account Receivable',
      path: SALES_URL + '/vmi/vmi-accounts-receivable?type=vmi-invoice',
      permission: 'account_recivable_menu'
    },
    // {
    //   label: 'VMI Paid Invoices',
    //   path: SALES_URL + '/vmi/vmi-paid-invoice?type=vmi-invoice',
    //   permission: 'paid_invoice_listing_menu'
    // },
  ],
},
  {
    label: 'VMI Sample Request',
    icon: FiGrid,
    permission: 'vmi_sample_request_menu',
    subMenu: [
      { 
        label: 'New VMI Sample Request', 
        path: SALES_URL + '/vmi-sample-request/vmi-sample-request-listing', 
        permission: 'vmi_sample_request_listing_menu' 
      },
      {
        label: 'Closed VMI Sample Request',
        path: SALES_URL + '/vmi-sample-request/vmi-closed-sample-request-listing',
        permission: 'vmi_closed_sample_request_menu'
      },
      {
        label: 'Cancelled VMI Sample Request',
        path: SALES_URL + '/vmi-sample-request/vmi-cancelled-sample-request-listing',
        permission: 'vmi_cancelled_sample_request_menu'
      },
    ],
  },
  {
    label: 'Sample Request',
    icon: FiGrid,
    permission: 'sample_request_menu',
    subMenu: [
      {
        label: 'New Sample Request',
        path: SALES_URL + '/sample-request/sample-list',
        permission: 'new_sample_request_menu'
      },
      {
        label: 'Closed Sample Request',
        path: SALES_URL + '/sample-request/closed-sample-listing-page',
        permission: 'closed_sample_request_menu'
      },
      {
        label: 'Cancelled Sample Request',
        path: SALES_URL + '/sample-request/cancelled-sample-list-page',
        permission: 'cancelled_sample_request_menu'
      },
      {
        label: 'Sourcing Failed Sample Request',
        path: SALES_URL + '/sample-request/sourcing-failed-sample-list-page',
        permission: 'sourcing_failed_sample_request_submenu'
      },
      {
        label: 'Sample Inventory',
        path: SALES_URL + '/sample-request/sample_inventory_listing',
        permission: 'sample_inventory_submenu'
      },
    ],
  },
  {
    label: 'Configuration',
    icon: FiSettings,
    path: SALES_URL + '/configuration',
    permission: 'configuration_menu'
  },
];

export default menuItems;
